import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const DefaultFileIcon = createSvgIcon(
  <g>
    <path d="M16 8h20l14 14v30c0 2.2-1.8 4-4 4H16c-2.2 0-4-1.8-4-4V12c0-2.2 1.8-4 4-4z" fill="#E2E8F0" />
    <path d="M16 8h20l14 14v30c0 2.2-1.8 4-4 4H16c-2.2 0-4-1.8-4-4V12c0-2.2 1.8-4 4-4z" fill="none" stroke="#64748B" strokeWidth="2" />
    <path d="M36 8v14h14" fill="none" stroke="#64748B" strokeWidth="2" />
    <path d="M20 34h24v2.8H20zm0 7h16v2.8H20z" fill="#64748B" />
  </g>,
  'DefaultFileIcon',
);
